export enum RestorePlanType {
  File = 0,
  BareMetal = 1,
  SystemState = 2,
  MSSQLDatabase = 3,
  MSSQLFiles = 4,
  VMwareMachine = 5,
  HyperV = 6,
  PostgreSQL = 7,
  Archive = 8,
  DiskImage = 9,
  VMFileLevel = 10,
  VMToCloud = 11,
  Proxmox
}
